// extracted by css-extract-rspack-plugin
export default {"cls1":"FacebookDisabledPage-cls1_dIR","cls2":"FacebookDisabledPage-cls2_kaa FacebookDisabledPage-cls1_dIR","show":"FacebookDisabledPage-show_0tt"};